import type { FC } from 'react';

import { SkeletonBodyCopy, SkeletonHeadline } from '@xing-com/skeleton';

import * as Styled from './loading-card.styled';
import type { LoadingCardProps } from './loading-card.types';
import { CardHeaderSection } from './sub-components';

export type { LoadingCardProps } from './loading-card.types';

export const LoadingCard: FC<LoadingCardProps> = () => (
  <Styled.LoadingCardContainer>
    <CardHeaderSection>
      <Styled.SkeletonHeaderContainer>
        <Styled.SkeletonHeadline amountRows={1} size="medium" />
        <SkeletonBodyCopy amountRows={2} />
      </Styled.SkeletonHeaderContainer>
    </CardHeaderSection>
    <Styled.LoadingCardBenefits>
      <SkeletonHeadline amountRows={1} size="medium" />
      <div>
        <SkeletonBodyCopy amountRows={2} />
        <SkeletonBodyCopy amountRows={2} />
        <SkeletonBodyCopy amountRows={2} />
      </div>
    </Styled.LoadingCardBenefits>
  </Styled.LoadingCardContainer>
);
